export default "__VITE_ASSET__C5iZ$dUe__"